import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/omni/Navbar";
import { Hero } from "@/components/omni/Hero";
import { Ticker } from "@/components/omni/Ticker";
import { Manifesto } from "@/components/omni/Manifesto";
import { SupportCTA } from "@/components/omni/SupportCTA";

function App() {
  useEffect(() => {
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduced) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App omni-noise" data-testid="omni-app">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Manifesto />
        <SupportCTA />
      </main>
    </div>
  );
}

export default App;
